import { BroadcastChannel } from "broadcast-channel";

/**
 * Cross-tab sign-out, scoped to a change of user.
 *
 * Arriving at /sso used to post a bare "logoutTabs" and every hidden tab signed
 * itself out. A hand-off URL is minted on every iframe navigation, so that made
 * a second tab of the *same* user impossible. The message now names whoever just
 * signed in, and a tab only leaves when someone else took the session over.
 */
const CHANNEL_NAME = "logout";

export const LOGOUT_OTHER_TABS = "logoutTabs";

let channel = null;

export const getLogoutChannel = () => {
  if (!channel) channel = new BroadcastChannel(CHANNEL_NAME);

  return channel;
};

/**
 * Tell other tabs who just signed in. Never throws: the only caller is the SSO
 * saga, where a rejection would be caught as ssoFailure and present a valid
 * login as a failed one. postMessage rejects on a closed channel.
 */
export const announceSignIn = async userId => {
  try {
    await getLogoutChannel().postMessage({
      type: LOGOUT_OTHER_TABS,
      userId: userId ?? null,
    });
  } catch {
    // Best effort.
  }
};

/**
 * True when a tab holding `currentUserId` should end its session.
 *
 * The bare string is what a tab still running the previous release posts. It
 * carries no identity, so it keeps the old behaviour of signing everyone out
 * rather than being ignored for the length of a deploy.
 */
export const shouldSignOut = (message, currentUserId) => {
  if (message === LOGOUT_OTHER_TABS) return true;
  if (!message || message.type !== LOGOUT_OTHER_TABS) return false;
  if (message.userId == null || currentUserId == null) return true;

  return message.userId !== currentUserId;
};
